import React from "react";

// Application context acts as global store
export const AppContext = React.createContext({});
